import { Box, Chip, TableCell, TableRow, useTheme } from '@mui/material'
import {
  ContainerCopyCell,
  NormalText,
  RowStyled,
  TableBodyStyled,
  TableCellStyled,
  TableHeadStyled,
  TableStyled,
  TooltipStyled,
} from '../../shared/styles'
import { ClipLoader } from 'react-spinners'
import {
  copyToClipboard,
  formatBlockTimestamp,
  formatLargeText,
  getTokenIcon,
} from '../../shared/utils'
import { Copy } from '@phosphor-icons/react'
import { useNavigate } from 'react-router-dom'

export const TablePortalTransactions = ({
  transactions,
  isLoadingTransactions,
  isErrorTransactions,
  credentialId,
}) => {
  const navigate = useNavigate()
  const { palette } = useTheme()

  const handleGoToTransactionDetail = (transactionId) => {
    navigate(`/transactions/${transactionId}`)
  }

  return (
    <TableStyled>
      <TableHeadStyled>
        <TableRow>
          <TableCell align="center">Transaction ID</TableCell>
          <TableCell align="center">From</TableCell>
          <TableCell align="center">To</TableCell>
          <TableCell align="center">Type</TableCell>
          <TableCell align="center">Date</TableCell>
          <TableCell align="center">Amount</TableCell>
          <TableCell align="center">Currency</TableCell>
        </TableRow>
      </TableHeadStyled>
      <TableBodyStyled>
        {isLoadingTransactions || !credentialId ? (
          <TableRow>
            <TableCell colSpan={6} align="center">
              <ClipLoader loading={true} size={24} color="#0197f6" />
            </TableCell>
          </TableRow>
        ) : transactions?.length ? (
          transactions?.map((row) => (
            <RowStyled
              key={row.id}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
                transition: 'background-color 0.3s ease',
                '&:hover': {
                  cursor: 'pointer',
                  backgroundColor: '#E3F3FD',
                },
              }}
              onClick={() => handleGoToTransactionDetail(row?.tx_hash)}
            >
              <TableCellStyled align="center">
                <ContainerCopyCell>
                  <TooltipStyled title={row?.tx_hash || '-'}>
                    {formatLargeText(row?.tx_hash || '-', 30)}
                  </TooltipStyled>
                  <TooltipStyled title="Copy" placement="top" withCopy>
                    <Copy
                      color={'#8C8C8C'}
                      size={16}
                      onClick={() => copyToClipboard(row?.tx_hash || '-')}
                    />
                  </TooltipStyled>
                </ContainerCopyCell>
              </TableCellStyled>
              <TableCellStyled align="center">
                <ContainerCopyCell>
                  <TooltipStyled title={row?.from_address || '-'}>
                    {formatLargeText(row?.from_address || '-', 40)}
                  </TooltipStyled>
                  <TooltipStyled title="Copy" placement="top" withCopy>
                    <Copy
                      color={'#8C8C8C'}
                      size={16}
                      onClick={() => copyToClipboard(row?.from_address || '-')}
                    />
                  </TooltipStyled>
                </ContainerCopyCell>
              </TableCellStyled>
              <TableCellStyled align="center">
                <ContainerCopyCell>
                  <TooltipStyled title={row?.to_address || '-'}>
                    {formatLargeText(row?.to_address || '-', 40)}
                  </TooltipStyled>
                  <TooltipStyled title="Copy" placement="top" withCopy>
                    <Copy
                      color={'#8C8C8C'}
                      size={16}
                      onClick={() => copyToClipboard(row?.to_address || '-')}
                    />
                  </TooltipStyled>
                </ContainerCopyCell>
              </TableCellStyled>
              <TableCellStyled align="center">
                <Chip
                  label={row?.direction?.toUpperCase() || '-'}
                  sx={{
                    color: palette.neutral.white,
                    fontWeight: 'bold',
                    fontSize: '12px',
                    borderRadius: '8px',
                    minWidth: '60px',
                    backgroundColor:
                      row?.direction === 'in' ? '#118FF0' : '#FF0000',
                  }}
                />
              </TableCellStyled>
              <TableCellStyled align="center">
                {formatBlockTimestamp(row.block_timestamp)}
              </TableCellStyled>
              <TableCellStyled align="center">
                <NormalText style={{ width: '100%' }}>{row?.amount}</NormalText>
              </TableCellStyled>
              <TableCellStyled align="center">
                <Box
                  display={'flex'}
                  gap={'4px'}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  {getTokenIcon(row?.asset_symbol) && (
                    <img
                      src={getTokenIcon(row?.asset_symbol)}
                      alt={row?.asset_symbol}
                      style={{ width: 24, height: 24, borderRadius: '50%' }}
                    />
                  )}
                  <NormalText color={'#0f110b'} isBold>
                    {row?.asset_symbol}
                  </NormalText>
                </Box>
              </TableCellStyled>
            </RowStyled>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={6}>
              <h5>
                {isErrorTransactions
                  ? 'Error al cargar las transacciones'
                  : 'No hay información para mostrar'}
              </h5>
            </TableCell>
          </TableRow>
        )}
      </TableBodyStyled>
    </TableStyled>
  )
}
